/*
 *  			'License for ONE AXA SOFTWARE - Inner Source'
 * 					L O A S - I S
 * 
 * The following License aims to be applied between the AXA Companies, according to the following definition:
 * "AXA Companies" means AXA, Société Anonyme with a “AXA Companies ” Board of Directors having its principal offices at 25, avenue Matignon, 75008 Paris, registered on the Commercial Registry of Paris under the number 572 093 920; and (i) any other company controlled by, or controlling AXA, with a company being considered as controlling another: (a) when it holds directly or indirectly a portion of the capital according to it the majority of the voting rights in general meetings of shareholders of this company; (b) when it holds solely the majority of the voting rights in this company by virtue of an agreement concluded with other partners or shareholders and which is not contrary to the interest of the company; (c) when it determines de facto, by voting rights which it holds, the decisions in the general meetings of shareholders of this company; (d) in any event, when it holds, directly or indirectly, a portion of voting rights greater than 40% and when no other partner or shareholder holds directly or indirectly a portion which is greater than its own; (ii) any economic interest group in which AXA and/or one or more other Companies of the AXA Group participates for at least 50% in operating costs; (iii) in the cases where the law applicable to a company limits voting rights or control (such as defined here in above), this company will be deemed to be a company of the AXA Group, if the voting rights in 2 Binding Corporate Rules – AXA Group – version 2013 general shareholders’ meetings or the control held by a Company of the AXA Group reaches the maximum amount fixed by said applicable law; and (iv) all AXA Companies constitute the “AXA Group” (hereafter "One AXA").  (Binding Corporate Rules - AXA Group - version 2019).
 * 
 * Software credits: 
 * 	Creator: AXA GO GETD
 * 	Main contributors: AXA GO GETD
 * 
 * Permission is hereby granted, free of charge, to any person or entity within One AXA obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software within One AXA, including the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
 * 
 * The above credit notice and this permission notice shall be included in all copies or substantial portions of the Software.
 * Any improvement or modification of the Software shall be made available to the whole One AXA, under the terms of this License.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */

/* eslint-disable react/destructuring-assignment */
import React from 'react';
import checkNodeType from './dialogGraphEvents/checkNodeType';

const TooltipNode = (props) => {
  let node = props.currentNode;

  if (!node) {
    node = {
      title: '0',
      response: ['0'],
      uniqueUsers: 0,
      visits: 0,
      lostUsers: 0,
    };
  }

  let isStart = false;
  if (checkNodeType({ node, typeToCheck: 'start' })) {
    isStart = true;
  }
  const dropOffPercentage = (totalVisits, dropOff) => {
    const percentage = parseFloat((dropOff / totalVisits) * 100).toFixed(0);
    if (Number.isNaN(percentage)) return 0;
    return percentage;
  };

  const BuildFallbacksTooltips = () => {
    if (!node.hasFallback) return <></>;

    const sourceFallback = [];
    const targetFallback = [];

    if (node.fallbackFrom) {
      for (let i = 0; i < node.fallbackFrom.length; i++) {
        sourceFallback.push(node.fallbackFrom[i]);
      }
    }

    if (node.fallbackTo) {
      for (let i = 0; i < node.fallbackTo.length; i++) {
        targetFallback.push(node.fallbackTo[i]);
      }
    }

    const sourceAndTarget = [];

    // Optimized way to delete duplicated and create a new array.
    if (sourceFallback.length && targetFallback.length) {
      for (let i = 0; i <= sourceFallback.length; i++) {
        const source = sourceFallback[i];
        if (source && source.id) {
          for (let k = 0; k < targetFallback.length; k++) {
            const target = targetFallback[k];
            if (source.id === target.id) {
              sourceAndTarget.push(target);
              targetFallback.splice(k, 1);
              break;
            }
          }
          sourceFallback.splice(i, 1);
          i -= 1;
        }
      }
    }

    return (
      <>
        Fallbacks:
        {sourceFallback.map((obj, i) => (
          <>
            {obj.id && (
              <li key={`${i}a`}>
                <a
                  href={`/manage-the-bot/flows/${obj.uid}/view?find=${encodeURI(
                    `dialog ${obj.id.substring(1)}`
                  )}`}
                >
                  {obj.id ? obj.id.substring(1) : undefined}
                </a>
                (Source)
              </li>
            )}
          </>
        ))}
        {targetFallback.map((obj, i) => (
          <>
            {obj.id && (
              <li key={`${i}b`}>
                <a
                  href={`/manage-the-bot/flows/${obj.uid}/view?find=${encodeURI(
                    `dialog ${obj.id.substring(1)}`
                  )}`}
                >
                  {obj.id.substring(1)}
                </a>
                (Target)
              </li>
            )}
          </>
        ))}
        {sourceAndTarget.map((obj, i) => (
          <>
            {obj.id && (
              <li key={`${i}c`}>
                <a
                  href={`/manage-the-bot/flows/${obj.uid}/view?find=${encodeURI(
                    `dialog ${obj.id.substring(1)}`
                  )}`}
                >
                  {obj.id.substring(1)}
                </a>
                (Source & target)
              </li>
            )}
          </>
        ))}
      </>
    );
  };

  const shortTextformater = (text) => {
    if (text.length > 40) {
      return `${text.slice(0, 40)}...`;
    }
    return `${text}`;
  };

  const url = node.uid
    ? `/manage-the-bot/flows/${node.uid}/view?find=${encodeURI(
        `dialog ${node.id.substring(1)}`
      )}`
    : false;

  return (
    <div
      id="dialogGraphTooltip"
      style={{
        fontSize: '1.1em',
        fontFamily: 'Source Sans Pro',
        background: '#ffffff',
        padding: '12px 0 12.1px',
        border: 'solid 1px #d5d5d5',
        boxShadow: '0 0 19px 0 rgb(0 0 0 / 18%)',
      }}
    >
      {!isStart && (
        <>
          <span
            style={{
              marginRight: '1em',
              marginLeft: '0.8em',
              fontSize: '1.4em',
              fontWeight: '600',
            }}
          >
            {node.title}
          </span>

          {url && (
            <>
              <a
                href={url}
                style={{
                  float: 'right',
                  marginRight: '1em',
                  marginTop: '0.25em',
                }}
              >
                View
              </a>
            </>
          )}

          <hr />
        </>
      )}

      <div style={{ marginLeft: '1em', marginRight: '1em' }}>
        {!isStart && (
          <>
            <div>id: {node.id}</div>
          </>
        )}
        {node.response &&
          node.response.map((text, index) => (
            <div key={index} style={{ width: '260px' }}>
              say: &quot;{shortTextformater(text)}&quot;
            </div>
          ))}
        {isStart ? (
          <>
            <div>
              <b>{node.uniqueUsersTotal}</b> Users that used flows
            </div>
            <div>
              <b> {node.visitsTotal}</b> Visits in all the dialogs
            </div>
          </>
        ) : (
          <>
            <div>
              Total users: <b> {node.uniqueUsers}</b>
            </div>
            <div>
              Total visits: <b> {node.visits}</b>
            </div>
          </>
        )}
        <div />
        {isStart ? (
          <>
            <div>
              <b>
                {node.lostUsers}{' '}
                <i style={{ fontSize: '13px' }}>
                  ({dropOffPercentage(node.visits, node.lostUsers)}%)
                </i>
              </b>{' '}
              Users Dropoff
            </div>
          </>
        ) : (
          <>
            <div>
              Lost Users (Dropoff):{' '}
              <b>
                {node.lostUsers}{' '}
                <i style={{ fontSize: '13px' }}>
                  ({dropOffPercentage(node.visits, node.lostUsers)}%)
                </i>
              </b>
            </div>
          </>
        )}
        <br />
        <BuildFallbacksTooltips />
      </div>
    </div>
  );
};

export default TooltipNode;
